import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import { Grid, Theme } from "@mui/material";
import React from "react";
import { useIntl } from "react-intl";

import { Button } from "../Button/Button";

export interface FooterProps {
  id?: string;
  labelNextButton?: string;
  labelPreviousButton?: string;
  labelSkipButton?: string;
  isNextDisabled?: boolean;
  isNextVisible?: boolean;
  isPreviousDisabled?: boolean;
  isPreviousVisible?: boolean;
  isSkipVisible?: boolean;
  onNextClick: () => void;
  onPreviousClick: () => void;
  onSkipClick: () => void;
}

export const Footer: React.FC<FooterProps> = ({
  id = "",
  labelNextButton = null,
  labelPreviousButton = null,
  labelSkipButton = null,
  isNextDisabled = false,
  isPreviousDisabled = false,
  isNextVisible = true,
  isPreviousVisible = true,
  isSkipVisible = false,
  onNextClick,
  onPreviousClick,
  onSkipClick,
}) => {
  const { formatMessage } = useIntl();

  const previousLabel =
    labelPreviousButton || formatMessage({ id: "footer.previousButton" });
  const nextLabel =
    labelNextButton || formatMessage({ id: "footer.nextButton" });
  const skipLabel =
    labelSkipButton || formatMessage({ id: "footer.skipButton" });

  const previousButton = isPreviousVisible && (
    <Button
      type="text"
      onClick={onPreviousClick}
      startIcon={<ArrowBackIos aria-hidden="true" />}
      disabled={isPreviousDisabled}
    >
      {previousLabel}
    </Button>
  );

  const nextButton = isNextVisible && (
    <Button
      type="text"
      onClick={onNextClick}
      endIcon={<ArrowForwardIos aria-hidden="true" />}
      disabled={isNextDisabled}
    >
      {nextLabel}
    </Button>
  );

  const skipButton = isSkipVisible && (
    <Grid
      item
      xs={12}
    >
      <Button
        type="underline"
        onClick={onSkipClick}
      >
        {skipLabel}
      </Button>
    </Grid>
  );

  return (
    <Grid
      id={id}
      component="footer"
      container
      direction="row"
      spacing="10"
      sx={(theme: Theme) => ({
        padding: "1rem 1.25rem",
        backgroundColor: "rgb(242, 241, 245)",
        zIndex: theme.zIndex.drawer - 1,
        textAlign: "center",
        position: "fixed",
        alignItems: "center",
        justifyContent: "space-between",
        left: 0,
        bottom: 0,
      })}
    >
      {skipButton}
      <Grid
        container
        sx={{
          justifyContent: "space-between",
          maxWidth: "689px",
          margin: "auto",
        }}
      >
        <Grid item>{previousButton}</Grid>
        <Grid item>{nextButton}</Grid>
      </Grid>
    </Grid>
  );
};
